<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon>
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Detalle</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Ventas Históricas</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-chart-bar</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Reporte de Ventas!</div>
          <div class="caption grey--text px-4 mb-6">El desglose detallado de ventas por producto ha sido procesado exitosamente.</div>

          <vue-json-to-csv
            :json-data="items"
            :labels="labels"
            :csv-title="`export_sales_detail_${moment().format('DD-MM-YYYY')}`"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar Detalle
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'
import numeral from 'numeral'

export default {
  name: "ExportProductSalesDetail",
  props: ['product', 'filter', 'options', 'disabled'],
  components: { VueJsonToCsv },
  data() {
    return {
      loading: false,
      items: [],
      dataReady: false,
      labels: {
        date: { title: 'Fecha' },
        work_order: { title: 'OT' },
        sales_note: { title: 'Cot.' },
        work_order_name: { title: 'Proyecto' },
        customer: { title: 'Cliente' },
        seller: { title: 'Vendedor' },
        qty: { title: 'Cant.' },
        mts2: { title: 'Mts2' },
        total_sales_price: { title: 'Venta' },
      }
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      if (Array.isArray(this.product)) {
        this.items = this.product.map(item => ({
          date: moment(item.date).format('DD/MM/YYYY'),
          work_order: item.work_order,
          sales_note: item.sales_note,
          work_order_name: item.work_order_name,
          customer: item.customer,
          seller: item.seller,
          qty: numeral(item.qty).format('0'),
          mts2: numeral(item.mts2).format('0,0.00'),
          total_sales_price: numeral(item.total_sales_price).format('0'),
        }))
        this.dataReady = true
      } else {
        notifications.showError('No hay datos para exportar')
      }
      this.loading = false
    },
    handleSuccess(val) {
      notifications.showSuccess('Ventas Exportadas')
      this.dataReady = false
    },
    handleError(val) {
      notifications.showError('Error Exportando Ventas')
      this.dataReady = false
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
</style>